import Sacrificer from './sacrificer.js';

export default class Wounded extends Sacrificer
{       
    constructor(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note){ 
        super(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note)

        // Related Data to Wounded
        this.skills                 = []
        this.Sacrifices             = []
        this.contacts               = []
        this.educations             = []
        this.selfEmployment         = null
        this.socialMedia            = null
        this.newIdentificationCard  = null
        this.oldIdentificationCard  = null
        this.passport               = null
        this.rationCard             = null
        this.residentialCard        = null

        this.init()
    }

    setSkills(skills){
        this.skills = skills
        return this
    }

    setSacrifices(Sacrifices){
        this.Sacrifices = Sacrifices
        return this
    }

    setContacts(contacts){
        this.contacts = contacts
        return this
    }

    setEducations(educations){
        this.educations = educations
        return this
    }
    
    setSelfEmployment(selfEmployment){
        this.selfEmployment = selfEmployment
        return this
    }

    setSocialMedia(socialMedia){
        this.socialMedia = socialMedia
        return this
    }

    setNewIdentificationCard(newIdentificationCard){
        this.newIdentificationCard = newIdentificationCard
        return this
    }

    setOldIdentificationCard(oldIdentificationCard){
        this.oldIdentificationCard = oldIdentificationCard
        return this
    }

    setPassport(passport){
        this.passport = passport
        return this
    }

    setRationCard(rationCard){
        this.rationCard = rationCard
        return this
    }

    setResidentialCard(residentialCard){
        this.residentialCard = residentialCard
        return this
    }
}

